export default "/img_bus.png";